import {Component} from "@angular/core";

@Component({
  selector: "common-ngclass",
  template: `
  <usecase-container title="NgClass" src="common/ngclass">
    <usecase-content>
      <input type="checkbox" [checked]="isWarning" (change)="isWarning = $event.target.checked">
      <span [ngClass]="{warning: isWarning}">あいうえお</span>
    </usecase-content>
  </usecase-container>
  `,
  styles: [".warning {color: red;}"]
})
export class NgClassComponent {
  isWarning = true;
}



/** WEBPACK FOOTER **
 ** ./script/common/ngclass/component.ts
 **/